<template>
  <div
    id="helper"
    :class="{ helperOpen: editorialPageState }"
    @click="editorialPageState = !editorialPageState"
    :style="{ color: contrastColor, background: mainColor }"
    style="text-align: left"
  >
    <svg
      class="active icon"
      viewBox="0 0 24 24"
      @mouseenter="hoverControll.close = true"
      @mouseleave="hoverControll.close = false"
    >
      <path
        class="white"
        :style="[hoverControll.close ? { fill: secondaryColor } : { fill: contrastColor }]"
        id="helperpath"
        d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      />
    </svg>
    <div id="helperCurtain"></div>
    <div id="helpBox">
      <h3>Nawigacja:</h3>
      <div class="left" v-if="!hiddenIcons.some((x) => x == 'zoom')">
        <svg width="calc(1080px * 0.06)" height="calc(1080px * 0.05)" viewBox="0 0 24 24">
          <path
            :fill="contrastColor"
            stroke="rgba(0,0,0,0.5)"
            stroke-width=".3"
            d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
          />
        </svg>
      </div>
      <div class="right" v-if="!hiddenIcons.some((x) => x == 'zoom')">
        <span>powiększenie elementu (lupka pojawia się po najechaniu na dany element planszy)</span>
      </div>
      <div class="left" v-if="!hiddenIcons.some((x) => x == 'return')">
        <svg width="calc(1080px * 0.06)" height="calc(1080px * 0.05)" viewBox="0 0 24 24">
          <path :fill="contrastColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
        </svg>
      </div>
      <div class="right" v-if="!hiddenIcons.some((x) => x == 'return')">
        <span>powrót do strony głównej</span>
      </div>
      <br v-if="!hiddenIcons.some((x) => x == 'return')" />
      <div class="left" v-if="!hiddenIcons.some((x) => x == 'next')">
        <svg
          width="calc(1080px * 0.05)"
          height="calc(1080px * 0.05)"
          viewBox="0 0 400 400"
          style="transform: rotate(180deg)"
        >
          <g>
            <path
              d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
              stroke-opacity="0"
              stroke-width="11"
              :fill="contrastColor"
            />
          </g>
        </svg>
        <svg width="calc(1080px * 0.05)" height="calc(1080px * 0.05)" viewBox="0 0 400 400">
          <g>
            <path
              d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
              stroke-opacity="0"
              stroke-width="11"
              :fill="contrastColor"
            />
          </g>
        </svg>
      </div>
      <div class="right" v-if="!hiddenIcons.some((x) => x == 'next')">
        <span>przejście do kolejnych lub poprzednich plansz</span>
      </div>
      <br v-if="!hiddenIcons.some((x) => x == 'next')" />
      <div class="left" v-if="!hiddenIcons.some((x) => x == 'nav')">
        <div id="helperNav">
          <div class="round mainRound" :style="{ background: contrastColor }"></div>
          <div class="round"></div>
          <div class="round"></div>
        </div>
      </div>
      <div class="right" v-if="!hiddenIcons.some((x) => x == 'nav')">
        <span>przejście do kolejnych lub poprzednich plansz lub wybór planszy</span>
      </div>
      <br v-if="!hiddenIcons.some((x) => x == 'nav')" />
      <div class="left" v-if="!hiddenIcons.some((x) => x == 'music')">
        <svg width="calc(1080px * 0.05)" height="calc(1080px * 0.05)" viewBox="0 0 24 24">
          <path
            :fill="contrastColor"
            d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
          />
        </svg>
      </div>
      <div class="right" v-if="!hiddenIcons.some((x) => x == 'music')">
        <span>włączona muzyka</span>
      </div>
      <br v-if="!hiddenIcons.some((x) => x == 'music')" />
      <div class="left" v-if="!hiddenIcons.some((x) => x == 'music')">
        <svg width="calc(1080px * 0.05)" height="calc(1080px * 0.05)" viewBox="0 0 24 24">
          <path
            :fill="contrastColor"
            d="M4.27 3L3 4.27l9 9v.28c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4v-1.73L19.73 21 21 19.73 4.27 3zM14 7h4V3h-6v5.18l2 2z"
          />
        </svg>
      </div>
      <div class="right" v-if="!hiddenIcons.some((x) => x == 'music')">
        <span class="afterSVG">wyłączona muzyka</span>
      </div>
      <br v-if="!hiddenIcons.some((x) => x == 'music')" />
      <div class="left" v-if="!hiddenIcons.some((x) => x == 'sound')">
        <svg class="audioIcon" viewBox="0 0 24 24" width="calc(1080px * 0.05)" height="calc(1080px * 0.05)">
          <path
            :fill="contrastColor"
            d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
          />
        </svg>
      </div>
      <div class="right" v-if="!hiddenIcons.some((x) => x == 'sound')">
        <span>włączony lektor</span>
      </div>
      <br v-if="!hiddenIcons.some((x) => x == 'sound')" />
      <div class="left" v-if="!hiddenIcons.some((x) => x == 'sound')">
        <svg class="audioIcon" viewBox="0 0 24 24" width="calc(1080px * 0.05)" height="calc(1080px * 0.05)">
          <path
            :fill="contrastColor"
            d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
          />
        </svg>
      </div>
      <div class="right" v-if="!hiddenIcons.some((x) => x == 'sound')">
        <span>wyłączony lektor</span>
      </div>
      <br v-if="!hiddenIcons.some((x) => x == 'sound')" />
      <div class="left" v-if="!hiddenIcons.some((x) => x == 'exit')">
        <svg viewBox="0 0 24 24" width="calc(1080px * 0.05)" height="calc(1080px * 0.05)">
          <path
            :fill="contrastColor"
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
      </div>
      <div class="right" v-if="!hiddenIcons.some((x) => x == 'exit')">
        <span>zamknięcie planszy</span>
      </div>
      <br v-if="!hiddenIcons.some((x) => x == 'exit')" />
      <hr />
      <div :key="'funkcjas' + index" v-for="(fn, index) in peopleList">
        <h4 class="normal">{{ fn.fnc }}</h4>
        <div :key="'ludz' + indexPpl + fn.fnc" v-for="(ppl, indexPpl) in fn.people">
          <i>{{ ppl }}</i>
          <br />
        </div>
        <br />
      </div>
      <hr />
      <div v-if="imgList.length > 0">
        <h4 class="normal">
          Wykaz dysponentów praw autorskich do obrazów i&nbsp;zdjęć zamieszczonych w&nbsp;publikacji:
        </h4>
        <div :key="'imglist' + indexImg" v-for="(imgL, indexImg) in imgList">
          <span v-html="imgL"></span>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'helper',
  props: {
    endClass: {
      type: Boolean,
    },
    autoPlayState: {
      type: Boolean,
    },
    contrastColor: {
      type: String,
      default: function () {
        return 'white';
      },
    },
    secondaryColor: {
      type: String,
      default: function () {
        return 'white';
      },
    },
    mainColor: {
      type: String,
      default: function () {
        return 'white';
      },
    },
    peopleList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    imgList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    hiddenIcons: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      hoverControll: {
        close: false,
      },
      editorialPageState: false,
    };
  },
  methods: {},
};
</script>
<style lang="sass" scoped>
@import '../../style/base'
@import '../../style/animation'
</style>
